<template>
  <div class="content" v-if="dataReady">
    <div class="row text-left">
      <div class="col-md-12">
        <p class="text-black-50">
          Новый шаблон
          <i v-on:click="addNewOne" class="tim-icons icon-single-copy-04"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" tuning="true" :a-page="true" :new-one="newOne"></big-one>
  </div>
</template>
<script>

const name = {header: "Наименование дкумента", name: "name", show: true, contains: ""};
const owner = {header: "Относится к", name: "owner", show: true, sort: true, direction: true, contains: false};
const ownerSelector = {selector: true, title: "Относится к", name: "owner", selectorList: null, contains: "all"}

export default{
  data() {
    return {
      type: "doc_pattern",
      content: [name, owner, ownerSelector],
      newOne: null,
      dataReady: false
    }
  },
  methods: {
    addNewOne() {
      let object = {name: '', owner: null, id: 0, fields: []};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    }
  },
  async mounted() {
    ownerSelector.selectorList = await this.$repo.getSelector("entities_types");
    this.dataReady = true;
  }
}
</script>
<style>
</style>
